import { Button, Row, Col, Stack, Utility, Chip } from '@workramp/ui';

interface SuggestionChipsProps {
  suggestions: string[];
  onSelectSuggestion: (suggestion: string) => void;
}

export function SuggestionChips({ suggestions, onSelectSuggestion }: SuggestionChipsProps) {
  // Define the handler outside of any conditionals to avoid React Hook errors
  const handleClick = (suggestion: string) => {
    onSelectSuggestion(suggestion);
  };

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <Stack size={2}>
      <Utility level="sm">Suggestions</Utility>
      <Row gapX={2} gapY={2} wrap="wrap">
        {suggestions.map((suggestion) => (
          <Col xs="auto" key={`suggestion-${suggestion}`}>
            <Button onPress={() => handleClick(suggestion)} variant="text-inline" color="primary" size="sm">
              <Chip>{suggestion}</Chip>
            </Button>
          </Col>
        ))}
      </Row>
    </Stack>
  );
}
